import store from '@/store';

export const whitelabelPlugin = {
  install() {
    if (!store) {
      console.error('Vuex store is required for the notification plugin!');
    }
  }
}
